export default __webpack_public_path__ + "static/media/1.7b0df4c4.png";